




import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
    components: {
    },
})
export default class PlayerAvatar extends Vue {
    @Prop() private userName!: string;

    get getImageUrl() {
        return 'https://eu.ui-avatars.com/api/?name=' + this.userName + '&rounded=true';
    }

}
